// Form Styling Labels
export const FORM_LABEL_TEXT = 'Form Modal';
export const FORM_FIELDS_LABEL_TEXT = 'Form Fields';
export const BUTTON_LABEL_TEXT = 'Button';
export const HEADLINE_LABEL = 'Headline';
export const ERRORS_LABEL = 'Errors';
export const HEADLINE_LOGO_LABEL = 'Logo';
export const FORM_BACKGROUND_IMAGE_LABEL = 'Background Image';
export const QUESTION_TEXT_LABEL = 'Question Text';
export const INPUT_TEXT_LABEL = 'Input Text';
export const HELPER_TEXT_LABEL = 'Helper Text';
export const INPUT_BACKGROUND = 'Input Background';
export const COLOR_PICKER_DEFAULT = 'Default';
export const COLOR_PICKER_HOVER = 'Hover';
export const COLOR_PICKER_FOCUS = 'Focus';
export const ERRORS_COLOR_LABEL = 'Error Color';
export const BUTTON_COLOR_LABEL = 'Button Color';
export const BUTTON_TEXT_LABEL = 'Button Text';
export const TEXT_ELEMENT_LABEL = 'Text Element';
export const ALIGNMENT_LABEL = 'Alignment';
export const ANSWER_COLOR_LABEL = 'Answer';
export const PLACEHOLDER_COLOR_LABEL = 'Placeholder';
export const PRIMARY_BUTTON_LABEL_TEXT = 'Primary Button';
export const SECONDARY_BUTTON_LABEL_TEXT = 'Secondary Button';
export const HEADLINES_LABEL = 'Headlines';
export const STEPPER_LABEL = 'Stepper';
export const SESSION_DETAILS_LABEL = 'Session Details';

export const HEADLINE_ALIGNMENT_LABEL = 'Headline Alignment';
export const HEADLINE_IMAGE_LABEL = 'Headline Image';
export const HEADLINE_FONT_LABEL = 'Headline Font';
export const BUTTON_ALIGNMENT_LABEL = 'Button Alignment';
export const TEXT_ELEMENT_ALIGNMENT_LABEL = 'Text Element Alignment';
export const TEXT_ELEMENT_FONT_LABEL = 'Text Element Font';
export const FORM_SIZE_LABEL = 'Modal Size';
export const FORM_SIZE_SPACING = 'Form Spacing';
export const FORM_BACKGROUND_LABEL = 'Form Background';
export const CLOSE_BUTTON_LABEL = 'Close Button';
export const FORM_LINKS_LABEL = 'Text Links';
export const ERRORS_FONT_LABEL = 'Error Font';
export const INPUT_WORD_LABEL = 'Input';
export const STEPPER_FONT_LABEL = 'Stepper Text';
export const STEPPER_PRIMARY_COLOR_LABEL = 'Stepper Primary Color';
export const STEPPER_SECONDARY_COLOR_LABEL = 'Stepper Secondary Color';
export const SESSION_DETAILS_TITLE_LABEL = 'Session Title';
export const SESSION_DETAILS_INFORMATION_LABEL = 'Session Information';
export const SESSION_DETAILS_TAG_TEXT_LABEL = 'Tag Text';
export const SESSION_DETAILS_TAG_BACKGROUND_LABEL = 'Tag Background';
export const SESSION_DETAILS_TAG_BORDER_LABEL = 'Tag';
export const SESSION_DETAILS_BADGE_TEXT_LABEL = 'Status Badge Text';
export const SESSION_DETAILS_BADGE_BACKGROUND_LABEL = 'Status Badge Background';
export const SESSION_DETAILS_BADGE_BORDER_LABEL = 'Status Badge';

// Ticket Styling Labels
export const STANDALONE_TICKET_LABEL = 'Master Ticket Styles';
export const STANDALONE_TICKET_SUB_LABEL_DEFAULT = 'All non styled tickets currently using master';
export const UNIQUE_STYLE_LABEL = 'Click to create a unique style for';
export const ADD_ON_TICKET_LABEL = 'Add On Ticket Styles';
export const ADD_ON_TICKET_SUB_LABEL_DEFAULT = `${UNIQUE_STYLE_LABEL} add on tickets`;
export const NESTED_TICKET_LABEL = 'Nested Ticket Styles';
export const NESTED_TICKET_SUB_LABEL_DEFAULT = `${UNIQUE_STYLE_LABEL} nested tickets`;
export const TICKET_SUB_LABEL_LAST_EDITED = 'Last edited';

// Ticket Panel Labels
export const TICKET_LABEL = 'Ticket';
export const NAME_LABEL = 'Name';
export const DESCRIPTION_LABEL = 'Description';
export const PRICE_LABEL = 'Price';
export const QUANTITY_LABEL = 'Quantity';
export const REMAINING_LABEL = 'Remaining Tickets';
export const DATE_TIME_LABEL = 'Date & Time';
export const SOLD_OUT_LABEL = 'Sold Out';
export const DEFAULT_PANEL_FONT_LABEL = 'Font';
export const TICKET_BORDER_PANEL_LABEL = 'Border';
export const TICKET_OVERLAY_PANEL_LABEL = 'Image Overlay';
export const TICKET_OPACITY_PANEL_LABEL = 'Ticket Opacity';
export const TICKET_INPUT_TYPE_PANEL_LABEL = 'Input Type';
export const TICKET_EMAIL_LABEL = 'Ticket Email';

export const QUANTITY_FONT_LABEL = 'Quantity Font';
export const TICKET_BACKGROUND_PANEL_LABEL = 'Ticket Background';

export const FORMAT_LABEL = 'Format';
export const REMAINING_TICKET_LABEL = 'Remaining Ticket';

export const SHOW_SOLD_OUT_LABEL = 'Show sold out tickets to guests.';
export const DISABLED_MESSAGE = `
There are no colors or fonts configured for this event.
You can set your own styles in the Design Tab and our Form Style Editor will rollout!
`;
